import React, { Component } from "react";
import { push } from "../Services/Analytics"

import "./FlipArrows.scss"

import dataJSON from "../../api/FlipPic.json"

class FlipArrows extends Component {
    constructor(props) {
        super();
        this.state = {}
    }
    swipeArrow(dir) {
        push("Scroll_Clicked", dir);
        if (dir == "Right") {
            this.props.switchFlip(Math.round(this.props.current + 1))
        } else {
            this.props.switchFlip(Math.round(this.props.current - 1))
        }
    }
    render() {
        return (
            <div className="arrows">
                <div onClick={(dir) => { this.swipeArrow("Right") }} className="right"></div>
                <div onClick={(dir) => { this.swipeArrow("Left") }} className="left"></div>
            </div>
        );
    }
}

export default FlipArrows;


// WEBPACK FOOTER //
// ./src/Components/FlipPic/FlipPic.arrows.js